import createEnum from 'lib/createEnum';

export const Actions = createEnum('URL_UPDATED', 'GLADLY_API_SHOW');
